import * as paths from './paths';
export default class HotspotConfigurator {
    constructor(configContainer, rootURL, settings, resourcesHandler, additional) {
        this.resourcesHandler = resourcesHandler;
        this.configContainer = configContainer;
        this.rootURL = rootURL;
        this.settings = settings;
        this.bandwidthId = 'hs-bandwidth-id';
        this.thresholdId = 'hs-threshold-id';
        this.symbolSizeId = 'hs-symbol-size-id';
        this.hotColorId = 'hs-hot-color-id';
        this.coldColorId = 'hs-cold-color-id';
        this.neutralColorId = 'hs-neutral-color-id';
        this.neutralVisibleId = 'hs-neutral-visible-id';
        this.spatialWeightId = 'hs-spatial-weight-id';
        this.entityId = 'hs-entity-id';
        this.entityFieldId = 'hs-entity-field-id';
        this.defaultWeightId = 'hs-default-weight-id';
        this.additional = additional;
    }

    init() {
        this._ensureHotspotStyles();
        this.configContainer.innerHTML = this._getTemplate();

        $("#" + this.bandwidthId).kendoNumericTextBox({
            format: "n0",
            decimals: 0,
            min: 1,
            appendTo: '#' + this.bandwidthId
        });
        $("#" + this.bandwidthId).data('kendoNumericTextBox').value(
            this.settings.Bandwidth != null ? this.settings.Bandwidth : 1000
        );

        $("#" + this.thresholdId).kendoNumericTextBox({
            format: "n2",
            decimals: 2,
            min: 0,
            step: 0.1,
            appendTo: '#' + this.thresholdId
        });
        $("#" + this.thresholdId).data('kendoNumericTextBox').value(
            this.settings.Threshold != null ? this.settings.Threshold : 2.0
        );

        $("#" + this.symbolSizeId).kendoNumericTextBox({
            format: "n0",
            decimals: 0,
            min: 1,
            appendTo: '#' + this.symbolSizeId
        });
        $("#" + this.symbolSizeId).data('kendoNumericTextBox').value(
            this.settings.SymbolSize != null ? this.settings.SymbolSize : 6
        );

        $("#" + this.defaultWeightId).kendoNumericTextBox({
            format: "n2",
            decimals: 2,
            min: 0,
            max: 1,
            step: 0.05,
            appendTo: '#' + this.defaultWeightId
        });
        $("#" + this.defaultWeightId).data('kendoNumericTextBox').value(
            this.settings.DefaultWeight != null ? this.settings.DefaultWeight : 0.3
        );

        $("#" + this.hotColorId).kendoColorPicker({ value: this.settings.HotColor || '#d7191c' })
            .data('kendoColorPicker').wrapper.css('width', '100%');
        $("#" + this.coldColorId).kendoColorPicker({ value: this.settings.ColdColor || '#2c7bb6' })
            .data('kendoColorPicker').wrapper.css('width', '100%');
        $("#" + this.neutralColorId).kendoColorPicker({ value: this.settings.NeutralColor || '#bbbbbb' })
            .data('kendoColorPicker').wrapper.css('width', '100%');

        let hasNeutralProp = Object.prototype.hasOwnProperty.call(this.settings, 'NeutralColor');
        let neutralEnabled = hasNeutralProp ? this.settings.NeutralColor != null : true;
        document.getElementById(this.neutralVisibleId).checked = neutralEnabled;
        this._syncNeutralPickerEnabled(neutralEnabled);

        $('#' + this.neutralVisibleId).on('change', (evt) => {
            this._syncNeutralPickerEnabled(evt.currentTarget.checked);
        });

        $("#" + this.spatialWeightId).kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: [
                { text: this.resourcesHandler.get('SpatialWeightBinary'), value: 'BINARY' },
                { text: this.resourcesHandler.get('SpatialWeightInverseDistance'), value: 'INVERSE_DISTANCE' }
            ],
            value: this.settings.SpatialWeight || 'BINARY'
        });

        if (this.additional == null || this.additional.idEntity == null) {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_LAYERS;
                            }
                        }
                    }
                },
                change: (evt) => {
                    $('#' + this.entityFieldId).data("kendoComboBox").value(null);
                    $('#' + this.entityFieldId).data("kendoComboBox").dataSource.read();
                }
            });

            if (this.settings.IdEntity) {
                $('#' + this.entityId).data("kendoComboBox").value(this.settings.IdEntity);
            }
        } else {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: []
            });

            $('#' + this.entityId).data("kendoComboBox").value(this.additional.idEntity);
            $('#hs-id-entity-wrapper').hide();
            $('#' + this.entityFieldId).closest('.col-4').removeClass('col-4').addClass('col-6');
            $('#' + this.defaultWeightId).closest('.col-4').removeClass('col-4').addClass('col-6');
        }

        let isEntity = (this.additional == null || this.additional.Type != 'Geoservice') ? true : false;

        if (this.additional == null || this.additional.fields == null) {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                if (isEntity) {
                                    return this.rootURL + paths.MAP_ENTITY_GET_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                } else {
                                    return this.rootURL + paths.MAP_GEOSERVICE_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                }
                            }
                        }
                    }
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        } else {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: this.additional.fields
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        }
    }

    save() {
        let neutralVisible = document.getElementById(this.neutralVisibleId).checked;
        return {
            Bandwidth: $("#" + this.bandwidthId).data('kendoNumericTextBox').value(),
            Threshold: $("#" + this.thresholdId).data('kendoNumericTextBox').value(),
            SymbolSize: $("#" + this.symbolSizeId).data('kendoNumericTextBox').value(),
            HotColor: $("#" + this.hotColorId).data('kendoColorPicker').value(),
            ColdColor: $("#" + this.coldColorId).data('kendoColorPicker').value(),
            NeutralColor: neutralVisible ? $("#" + this.neutralColorId).data('kendoColorPicker').value() : null,
            SpatialWeight: $("#" + this.spatialWeightId).data('kendoDropDownList').value(),
            IdEntity: $('#' + this.entityId).data("kendoComboBox").value(),
            IdEntityField: $('#' + this.entityFieldId).data('kendoComboBox').value(),
            DefaultWeight: $("#" + this.defaultWeightId).data('kendoNumericTextBox').value(),
            Type: 'HOTSPOT'
        };
    }

    _syncNeutralPickerEnabled(enabled) {
        const picker = $("#" + this.neutralColorId).data('kendoColorPicker');
        if (picker != null) {
            picker.enable(enabled);
            picker.wrapper.css('opacity', enabled ? '1' : '0.5');
        }
    }

    _ensureHotspotStyles() {
        if (document.getElementById('xp-hotspot-styles')) return;

        const style = document.createElement('style');
        style.id = 'xp-hotspot-styles';
        style.textContent =
            '.xp-hotspot-section-title {' +
                'display:flex;align-items:center;gap:10px;' +
                'margin:14px 0 10px 0;padding:0;' +
                'font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;' +
                'color:var(--theme-primary-700);' +
            '}' +
            '.xp-hotspot-section-title::after {' +
                'content:"";flex:1;height:1px;background:var(--theme-primary-700);opacity:0.25;' +
            '}' +
            '.xp-hotspot-section-title:first-child {' +
                'margin-top:4px;' +
            '}' +
            '.xp-hotspot-form .form-label {' +
                'font-size:12px;margin-bottom:3px;color:#555;font-weight:500;' +
            '}' +
            '.xp-hotspot-form .col-3.mb-3,' +
            '.xp-hotspot-form .col-4.mb-3,' +
            '.xp-hotspot-form .col-6.mb-3,' +
            '.xp-hotspot-form .col-12.mb-3 {' +
                'margin-bottom:10px !important;' +
            '}' +
            '.xp-hotspot-form .k-colorpicker {' +
                'width:100%;border-radius:4px;' +
            '}' +
            '.xp-hotspot-neutral-row {' +
                'display:flex;align-items:center;gap:8px;' +
            '}' +
            '.xp-hotspot-neutral-row input[type="checkbox"] {' +
                'margin:0;cursor:pointer;flex-shrink:0;width:16px;height:16px;' +
            '}' +
            '.xp-hotspot-neutral-row .k-colorpicker {' +
                'flex:1 1 auto;min-width:0;' +
            '}';

        document.head.appendChild(style);
    }

    _getTemplate() {
        const r = this.resourcesHandler;
        return `<div class="form-group col-12 xp-hotspot-form">
                    <div class="col-12 xp-hotspot-section-title">${r.get('HotspotSection_Statistics')}</div>
                    <div class="form-row">
                        <div class="col-3 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('Bandwidth')}</label>
                                <input class="form-control" id="${this.bandwidthId}">
                            </div>
                        </div>
                        <div class="col-3 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('Threshold')}</label>
                                <input class="form-control" id="${this.thresholdId}">
                            </div>
                        </div>
                        <div class="col-3 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('SymbolSize')}</label>
                                <input class="form-control" id="${this.symbolSizeId}">
                            </div>
                        </div>
                        <div class="col-3 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('SpatialWeight')}</label>
                                <input class="form-control" id="${this.spatialWeightId}">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 xp-hotspot-section-title">${r.get('HotspotSection_Weighting')}</div>
                    <div class="form-row">
                        <div class="col-4 mb-3" id="hs-id-entity-wrapper">
                            <div class="form-group">
                                <label class="form-label">${r.get('Entity')}</label>
                                <div class="form-control" id="${this.entityId}"></div>
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('WeightField')}</label>
                                <input class="form-control" id="${this.entityFieldId}">
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('DefaultWeight')}</label>
                                <input class="form-control" id="${this.defaultWeightId}">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 xp-hotspot-section-title">${r.get('HotspotSection_Colors')}</div>
                    <div class="form-row">
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('HotColor')}</label>
                                <input id="${this.hotColorId}">
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('ColdColor')}</label>
                                <input id="${this.coldColorId}">
                            </div>
                        </div>
                        <div class="col-4 mb-3">
                            <div class="form-group">
                                <label class="form-label">${r.get('NeutralColor')}</label>
                                <div class="xp-hotspot-neutral-row">
                                    <input type="checkbox" id="${this.neutralVisibleId}">
                                    <input id="${this.neutralColorId}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
    }
}
